import Button from "@commons/Button";
import SelectInput from "@commons/Input/Select";
import Text from "@commons/Typography/Text";
import TextInput from "@commons/Input/Text";
import SearchIcon from "@mui/icons-material/Search";
import { SITUATION_OPTIONS } from "@typings/entities/individuals";
import ComboBox from "@commons/Input/ComboBox";
import { useState } from "react";
import type { ComboBoxOption } from "@typings/components/comboBox";
import { searchTaxonomic } from "@services/taxonomicGroups/search";
import type { TaxonomicGroup } from "@typings/entities/taxonomicGroup";
import { SORT_BY_OPTIONS } from "@typings/components/filters";
import type { TableFilters } from "@typings/entities/individuals/table";

type TableFilterProps = {
  filters: TableFilters;
  onChange: (field: keyof TableFilters, value: string) => void;
  onApply: () => void;
};

function TableFilter({ filters, onChange, onApply }: TableFilterProps) {
  const [selectedSpecies, setSelectedSpecies] =
    useState<ComboBoxOption<TaxonomicGroup> | null>(null);

  const hasEntrada = !!filters.createdAtStart || !!filters.createdAtEnd;
  const hasSoltura = !!filters.releasedAtStart || !!filters.releasedAtEnd;

  return (
    <div className="space-y-4">
      <section>
        <Text className="mb-2">Período de Entrada</Text>
        <div className="grid grid-cols-1 xs:grid-cols-2 gap-3 max-w-lg">
          <TextInput
            textSize="small"
            type="datetime-local"
            fullWidth
            disabled={hasSoltura}
            value={filters.createdAtStart}
            onChange={(e) => onChange("createdAtStart", e.target.value)}
          />
          <TextInput
            textSize="small"
            type="datetime-local"
            fullWidth
            disabled={hasSoltura}
            value={filters.createdAtEnd}
            onChange={(e) => onChange("createdAtEnd", e.target.value)}
          />
        </div>
      </section>

      <section>
        <Text className="mb-2">Período de Soltura</Text>
        <div className="grid grid-cols-1 xs:grid-cols-2 gap-3 max-w-lg">
          <TextInput
            textSize="small"
            type="datetime-local"
            fullWidth
            disabled={hasEntrada}
            value={filters.releasedAtStart}
            onChange={(e) => onChange("releasedAtStart", e.target.value)}
          />
          <TextInput
            textSize="small"
            type="datetime-local"
            fullWidth
            disabled={hasEntrada}
            value={filters.releasedAtEnd}
            onChange={(e) => onChange("releasedAtEnd", e.target.value)}
          />
        </div>
      </section>

      <section className="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 xl:grid-cols-6 2xl:grid-cols-9 gap-3 w-full max-w-xl sm:max-w-none">
        <ComboBox<TaxonomicGroup>
          value={selectedSpecies}
          onChange={(e) => {
            setSelectedSpecies(e);
            onChange("taxonomicGroupId", e?.value ?? "");
          }}
          searchService={searchTaxonomic}
          label="Espécie"
          minSearchLength={0}
          debounceTime={300}
        />

        <SelectInput
          size="small"
          label="Situação"
          options={SITUATION_OPTIONS}
          fullWidth
          value={filters.situation}
          onChange={(e) => onChange("situation", e.target.value as string)}
        />
        <SelectInput
          size="small"
          label="Ordenar"
          options={SORT_BY_OPTIONS}
          fullWidth
          value={filters.sortOrder}
          onChange={(e) => onChange("sortOrder", e.target.value as string)}
        />

        <div className="flex items-end">
          <Button
            startIcon={<SearchIcon />}
            customVariant="primary"
            size="full"
            onClick={onApply}
          >
            Filtrar
          </Button>
        </div>
      </section>
    </div>
  );
}

export default TableFilter;
